import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "df-tax"
};
import { computed } from "vue";
import { useDonation } from "../../context/donationContext";
import { useChrome } from "../../i18n/useChrome";
import { resolveTaxReduction } from "../../composables/taxReduction";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TaxReductionStatement',
    setup(__props) {
        // SYNC: see ../../_SYNC.md.
        const { config, state, amountMinor, currency, formatMinor } = useDonation();
        const { tf } = useChrome();
        const reduction = computed(() => resolveTaxReduction(config.document.settings, currency.value, state.donorType, state.country, amountMinor.value));
        const message = computed(() => {
            const value = reduction.value;
            return value === null
                ? ""
                : tf(`taxReduction.${value.variant}`, {
                    amount: formatMinor(value.amountMinor),
                    netAmount: formatMinor(value.netMinor),
                });
        });
        return (_ctx, _cache) => {
            return (message.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(message.value), 1 /* TEXT */))
                : _createCommentVNode("v-if", true);
        };
    }
});
